
import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseMixin } from "@/mixins/baseMixin";

@Component({
  components: {},
  mixins: [BaseMixin]
})
export default class ApproveButton extends Vue {
  public name: string = "ApproveButton";

  @Prop({ default: "" })
  public to: any;

  private approve(): void {
    this.$emit("click");
  }
}
